import * as React from 'react';
import { Typography } from '@material-ui/core';
import moment from 'moment';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row' as 'row',
    marginTop: 15,
  },
  image: {
    backgroundImage: 'url(/static/img/eho_dark_logo.png)',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    height: 36,
    margin: '0 20px 0 0',
    width: 30,
  },
  licenseText: {
    color: '#323232',
    fontSize: 12,
    lineHeight: 18,
    textAlign: 'left' as 'left',
  },
};

const ToriiLicense = () => {
  const currentYear = moment().format('YYYY');

  return (
    <div style={styles.container}>
      <div style={styles.image} />
      <div>
        <Typography style={styles.licenseText}>
          © {currentYear} Torii, Inc. All Rights Reserved.
        </Typography>
        <Typography style={styles.licenseText}>
          MA License #422946, CA DRE #02112597
        </Typography>
      </div>
    </div>
  );
};

export default ToriiLicense;
